import { render, staticRenderFns } from "./ShoppableDropzone.vue?vue&type=template&id=63c3028f"
import script from "./ShoppableDropzone.vue?vue&type=script&lang=js"
export * from "./ShoppableDropzone.vue?vue&type=script&lang=js"
import style0 from "./ShoppableDropzone.vue?vue&type=style&index=0&id=63c3028f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports